import { BaseText, Button, theme } from 'aimo-ui';
import useUserPermitOrderLine from 'hooks/useUserPermitOrderLine.tsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { StyledWrapper } from 'styles/ContainerStyles.ts';
import {
  LicensePlate,
  Maybe,
  ParkingSpace,
} from 'types/generatedSchemaTypes.ts';
import { useUiStore } from 'stores/uiStore';

type OrderLineProps = {
  propertyName: 'parkingSpaces' | 'registrationPlates';
};

const PermitOrderLineModalContent: React.FC<OrderLineProps> = ({
  propertyName,
}: OrderLineProps) => {
  const { t } = useTranslation();
  const orderLineIdWithVersion = usePermitStore(
    (state) => state.selectedPermit
  );
  const setSelectedPermit = usePermitStore((state) => state.setSelectedPermit);
  const items =
    useUserPermitOrderLine(orderLineIdWithVersion)?.[propertyName] ?? [];

  const extractName = (
    item: Maybe<ParkingSpace> | Maybe<LicensePlate>
  ): string => {
    if (propertyName === 'parkingSpaces') {
      return (item as ParkingSpace)?.name;
    }
    if (propertyName === 'registrationPlates') {
      return (item as LicensePlate)?.plateText;
    }

    return '';
  };

  const modalContext = items
    .map(extractName)
    .filter((name): name is string => Boolean(name))
    .sort((a, b) => a.localeCompare(b))
    .join(', ')
    .concat('.');

  return (
    <>
      <StyledWrapper
        center={true}
        mb={50}
        testID={'permit-parking-space-modal'}>
        <BaseText color={theme.colors.gray300}>{modalContext}</BaseText>
      </StyledWrapper>
      <StyledWrapper>
        <Button
          size="l"
          onPress={() => {
            setSelectedPermit(undefined);
            useUiStore.getState().setSheetModal('');
          }}
          text={t('button.close')}
          testID="close-button"
        />
      </StyledWrapper>
    </>
  );
};

export default PermitOrderLineModalContent;
